// dependencies
import { isValid } from "date-fns";

// utils
import guessDate from "./guessDate";

/**
 * I secrectly just use chrono. shhhhhhhhh.
 */
const isValidDateString = (value: string) => {
	const bestGuess = guessDate(value, false);
	const valid = isValid(bestGuess);

	return {
		isValid: valid,
		date: valid ? bestGuess : null,
	};
};

export default isValidDateString;
